import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const FeedbackModal = ({ show, onHide, onSubmit }) => {
  const [reason, setReason] = useState("");

  const handleSubmit = () => {
    onSubmit(reason);
    setReason("");
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Provide Feedback</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted mb-2">Why was this response not helpful?</p>
        <Form.Group>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="e.g. The information was outdated..."
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="danger"
          onClick={handleSubmit}
          disabled={!reason.trim()}
        >
          Submit Feedback
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FeedbackModal;
